module.exports = __webpack_public_path__ + "img/alert.4c991f2a.svg";